export var getDefaultStyleSheet = _ref => {
  var {
    designContext,
    pressed,
    focused,
    hovered
  } = _ref;
  return {
    rootStyle: {
      backgroundColor: pressed || hovered || focused ? designContext.get('colors/backgrounds/default', {
        interactiveState: pressed ? 'pressed' : 'hovered'
      }).toString() : designContext.get('colors/backgrounds/transparent').toString(),
      position: 'absolute',
      transition: 'background-color .2s ease',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: -1
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map